import styled from "styled-components"

export const Wrapper = styled.div`
    width: 50%;
`

export const Content = styled.div`
    width: 100%;
    padding: 20px 0 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: flex-start;
`
